import { render, staticRenderFns } from "./mulSchemes.vue?vue&type=template&id=cca62e22&scoped=true"
import script from "./mulSchemes.vue?vue&type=script&lang=js"
export * from "./mulSchemes.vue?vue&type=script&lang=js"
import style0 from "./mulSchemes.vue?vue&type=style&index=0&id=cca62e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca62e22",
  null
  
)

export default component.exports